import defaultStyles from "./who-we-serve-default.module.scss";
import "./who-we-serve-mobile.module.scss";
import DomPurify from "isomorphic-dompurify";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LayoutStyleTypes, LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import classNames from "classnames";
import { FixBreadcrumb, useBreadcrumbs } from "@/elements-react/fix-breadcrumb";
import { Url } from "@/helpers/url.ts";

export function useWhoWeServeCommon(staticPageContent: string) {
  const { t } = useTranslation();
  const { layoutType } = useLayoutType();

  const isMobile = layoutType === LayoutTypes.TYPE_MOBILE;
  const content = useMemo(() => {
    return DomPurify.sanitize(staticPageContent);
  }, [staticPageContent]);

  const breadcrumbs = [
    {
      label: t("zv7t2q5m8n1c4r6k.who-we-serve", "Who we serve"),
      url: Url.to("who-we-serve-page"),
    },
  ];

  useBreadcrumbs(breadcrumbs);

  const renderContent = () => {
    const contentClassnames = classNames({
      [defaultStyles[LayoutStyleTypes.TYPE_SM]]: isMobile,
    });

    return (
      <div className={defaultStyles.wrapper}>
        <div className={contentClassnames}>
          <div className="static-page-content">
            <div className={defaultStyles.breadcrumbsNavigation}>
              <FixBreadcrumb />
            </div>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </div>
    );
  };

  return {
    renderContent,
  };
}
